(() => {
  class LoadMore extends HTMLElement {
    constructor() {
      super();
      this.items = [];
      this.page = 1;
      this.insertSelector = this.getAttribute('insert-selector');
      this.itemSelector = this.getAttribute('item-selector');
      this.paginationSelector = this.getAttribute('pagination-selector');
      this.button = this.querySelector('button');
      this.counter = this.querySelector('.counter');
    }

    connectedCallback() {
      this.button.addEventListener('click', () => this.loadMore());
      this.handleFilters();
      this.refresh();
    }

    handleFilters() {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach(mu => {
          if (mu.type !== "attributes" && mu.attributeName !== "class") return;
          if (mu.target.classList.contains('ajax-loading')) {
            this.loading();
            return;
          }
          this.refresh();
        });
      });

      const observables = document.querySelectorAll(".utility-bar[data-ajax-container]");
      observables.forEach(el => observer.observe(el, { attributes: true }));
    }

    handleImages() {
      theme?.ProductBlockManager?.loadImages(this.container);
    }

    loading() {
      this.button.disabled = true;
      this.style.opacity = 0;
    }

    complete() {
      if (this.items.length < 1) {
        this.counter.innerText = '';
        this.button.style.display = 'none';
        return;
      }
      this.button.disabled = false;
      this.button.style.display = 'inherit';
      this.style.opacity = 1;
      this.counter.innerText = `Show next ${this.items.length} items`;
    }

    refresh() {
      this.page = 1;
      this.hideDefaultPagination();
      this.prepareNextItems();
    }

    async prepareNextItems() {
      let url = this.nextPageUrl(this.page);
      let items = await this.fetchItems(url);
      /* disable animations */
      items.forEach(el => el.removeAttribute('data-cc-animate'));
      this.items = items;
      this.page++;
      this.complete();
    }

    async loadMore() {
      this.loading();
      this.insertItems(this.items);
      await this.prepareNextItems();
      this.complete();
    }

    get container() {
      return document.querySelector('main ' + this.insertSelector);
    }

    insertItems(items) {
      this.container.append(...items);
      this.handleImages();
    }

    hideDefaultPagination() {
      document.querySelectorAll('main ' + this.paginationSelector).forEach(el => el.style.display = 'none');
    }

    nextPageUrl(current_page) {
      let params = new URLSearchParams(window.location.search);
      let page = current_page || params.get('page') || 1;
      params.set('page', page + 1);
      let sectionId = this.container?.closest('[data-section-id]')?.getAttribute('data-section-id');
      if (sectionId) {
        params.set('section_id', sectionId);
      }
      return window.location.pathname + '?' + params.toString();
    }

    async fetchItems(url) {
      let res = await fetch(url);
      let text = await res.text();
      const parser = new DOMParser();
      const html = parser.parseFromString(text, 'text/html');
      return html.querySelectorAll(`${this.insertSelector} ${this.itemSelector}`);
    }
  }

  function initCustomElement() {
    !window.customElements.get('custom-subscribe') && window.customElements.define('load-more', LoadMore);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCustomElement);
  } else {
    initCustomElement();
  }

  window.addEventListener('shopify:section:load', initCustomElement);

})();
